var $ = require('jquery');

$(document).ready(function() {
    initGroup();
})
function initGroup() {
    var groupTriangle = '.page-section--main > .wp-block-group.is-style-triangle';
    var groupBackground = '.page-section--main > .wp-block-group.has-background';
    
    $(groupTriangle + "," + groupBackground).each(function() {
        $(this).children().wrapAll('<div class="wp-block-group__inner-container"></div>');
    })
    $('.page-section--main > .wp-block-group').each(function() {
        var prev = $(this).prev();

        if(prev.length == 0) {
            $(this).addClass('-banner');
        }

        if ( $(this).children().last().hasClass('wp-block-embed') && $(this).next().hasClass('testimonials') ) {
            $(this).addClass('overlap');
        }
    })
}
